var map = {
	"./animentor.svg": 54,
	"./chillmate.png": 55,
	"./exchange-rates.svg": 56,
	"./gasp.svg": 57,
	"./inverted-corners.svg": 58,
	"./link-verification-for-mastodon.svg": 59,
	"./palermo.svg": 60,
	"./pastitsio.svg": 61,
	"./peasant.svg": 62,
	"./savitar.svg": 63,
	"./socketio-whiteboard.svg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;